import { setupConnectJs } from '@atlassian/jira-connect/src/index.tsx';
import type { Action } from '../types.tsx';

export const withConnectHost = async (action: Action): Promise<void> => {
	const connectHost = await setupConnectJs();
	action(connectHost);
};

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const getConnectHost = () => window.connectHost;

export const isConnectDialogWebItem = (classes: string | string[]) =>
	classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');
